export const wordPluralize = (
  count: number,
  noun: string,
  suffix = 's',
): string => `${noun}${count !== 1 ? suffix : ''}`;
